import Axios from "axios";
import config from "../app.config";

export var contactsService;
export default contactsService = {
    getContacts,
    getContact,
    createNewContact,
    updateContact,
    deleteContact,
}

async function getContacts(payload){
    return await Axios.get(`${config.LOCAL_API_URL}/contacts`,{params: payload})
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error);
    })
}
async function getContact(id){
    return await Axios.get(`${config.LOCAL_API_URL}/contacts/${id}`)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function createNewContact(params){
    return await Axios.post(`${config.LOCAL_API_URL}/contacts`, params)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function updateContact(data){
    return await Axios.put(`${config.LOCAL_API_URL}/contacts/${data.id}`, data)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function deleteContact(id){
    return await Axios.delete(`${config.LOCAL_API_URL}/contacts/${id}`)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
